import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ModalService, AddFavoriteNameService } from '@core/services/index';
import { Component, OnInit, OnDestroy, } from '@angular/core';

import { ValidationService } from '@core/services';
import { UpdateTrigger } from '@shared/components/validation-message';

@Component({
  moduleId: module.id,
  selector: 'app-favname-body',
  templateUrl: './add-favorite-name.component.html',
  styleUrls: ['./add-favorite-name.component.less']
})


export class AddFavoriteNameModalComponent implements OnInit, OnDestroy {

  public favForm: UntypedFormGroup;
  private subscriptions = new Subscription();
  public loading: boolean;
  // Set enum from validation message service to be a member variable of this class
  updateTrigger: any = UpdateTrigger;

  constructor(
    private fb: UntypedFormBuilder,
    private modalService: ModalService,
    private addFavoriteNameService: AddFavoriteNameService
  ) {
    this.loading = false;

    this.createForm();

  }

  ngOnInit() {
    // Hiding the close button
    const element = <HTMLElement>document.querySelector('#modalHeader');
    if (element) {
      element.style.display = 'none';
    }
  }


  createForm() {
    this.favForm = this.fb.group({
      favName: new UntypedFormControl(null, [ValidationService.validateFavName])
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  showModal(name: string, autoHide: boolean = true, navigateFromFav: boolean = false) {
    this.addFavoriteNameService.setNavigateFromFav(navigateFromFav);
    this.modalService.setModalSelector(name);
    this.modalService.showModal(autoHide);
  }

  onSubmit(favForm) {
    if (favForm.favName !== null && favForm.favName !== ' ') {
      this.loading = true;

      const formModel = this.favForm.value;
      const userData: any = {
        favName: formModel.favName as string,
      };

      this.addFavoriteNameService.setFavname(userData.favName);
      this.loading = false;

      this.modalService.hideModal();

    } else {
      this.loading = false;
    }

  }

  cancel() {
    this.modalService.hideModal();
  }

}
